module.exports = __webpack_public_path__ + "media/svg-new/imagem-exercicio-a34abf64.svg";